export * from './bereichs-sorter.component';
export * from './bereichs-sorter.component.module';